import type { CommonSite } from '@awazevr/mfe-common.types-and-mocks.site-search-service'

import { MAX_CARDS } from './PropertiesNearby'
import { toCarouselSafeCode } from './usePropertyCardMapper'

// Mirrors the mapper (drops code-less properties) then the carousel cap, so it
// matches exactly the cards on screen.
export const getDisplayedExpandedProperties = (
  properties: CommonSite[],
): CommonSite[] =>
  properties.filter((property) => Boolean(property.code)).slice(0, MAX_CARDS)

// The card's `code` is the carousel-safe form, so match through the same
// transform rather than against the bare code.
export const findClickedExpandedProperty = (
  displayedProperties: CommonSite[],
  cardCode: string,
): CommonSite | undefined =>
  displayedProperties.find(
    (property) => toCarouselSafeCode(property.code) === cardCode,
  )
